// extracted by mini-css-extract-plugin
module.exports = {"scopeCell":"style_scopeCell__38DBj","defineScope":"style_defineScope__1JeQ4"};